// =============================================================================
// Changelog — "o que mudou", a um clique da versão.
//
// Aparece ao clicar na versão, no rodapé da barra lateral. Existe por um motivo
// prático: quando o vendedor liga dizendo que "sumiu" ou que "mudou de lugar",
// a primeira pergunta é qual versão ele está vendo — e a segunda é o que mudou
// nela. As duas respostas passam a estar na tela dele.
//
// ⚠️ O conteúdo mora em `changelog.js` e é escrito para quem VENDE. Aqui só se
//    resolve como mostrar.
// =============================================================================

import { useEffect } from 'react';
import { VERSOES, TIPOS } from '../changelog';

const dataBR = (iso) => String(iso || '').slice(0, 10).split('-').reverse().join('/');

export default function Changelog({ aoFechar }) {
  useEffect(() => {
    const tecla = (e) => { if (e.key === 'Escape') aoFechar(); };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, [aoFechar]);

  return (
    <div className="changelog nao-imprimir" onClick={aoFechar} role="dialog" aria-label="O que mudou no Fênix">
      <div className="changelog__painel" onClick={(e) => e.stopPropagation()}>
        <div className="changelog__topo">
          <div>
            <h2 className="changelog__titulo">O que mudou no Fênix</h2>
            <div className="changelog__sub">
              Você está na versão <strong>{VERSOES[0].versao}</strong>
            </div>
          </div>
          <button type="button" className="changelog__fechar" onClick={aoFechar} aria-label="Fechar">
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div className="changelog__corpo">
          {VERSOES.map((v, i) => (
            <section key={v.versao} className="changelog__versao">
              <div className="changelog__versao-bar">
                <span className="changelog__versao-num">{v.versao}</span>
                <span className="changelog__versao-data">{dataBR(v.data)}</span>
                {/* A de cima é a que está rodando — dizer isso evita a dúvida
                    de quem abre a tela e não sabe onde ele mesmo está. */}
                {i === 0 && <span className="changelog__versao-atual">em uso</span>}
              </div>
              {v.resumo && <p className="changelog__resumo">{v.resumo}</p>}
              <ul className="changelog__lista">
                {v.mudancas.map((m, j) => {
                  const t = TIPOS[m.tipo] || TIPOS.melhoria;
                  return (
                    <li key={j} className={`changelog__item e-${m.tipo}`}>
                      <span className="changelog__tag">
                        <i className={`bi ${t.icone}`} /> {t.rotulo}
                      </span>
                      <span>{m.texto}</span>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
